import type { EnumUnion } from "@dresscode-frontend/utility-types";

export const WorkerType = {
  EMPLOYEE: "EMPLOYEE",
  BOARD_MEMBER: "BOARD_MEMBER",
  CONTRACTOR: "CONTRACTOR",
  COLLABORATOR: "COLLABORATOR",
} as const;
export type WorkerType = EnumUnion<typeof WorkerType>;

export type LowerWorkerType = Lowercase<WorkerType>;

// NOTE. 厳密に言うと日本においてBOARD_MEMBERは2年ないしは1年の有期契約が原則になるが、海外だと無期があり得るのと、上場・未上場によっても異なるので安全側に倒す意味でBOARD_MEMBERも無期にできるようにしている
export const canUnlimitContractTerm = (workerType: WorkerType) =>
  workerType === "BOARD_MEMBER" || workerType === "EMPLOYEE";
